import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Tooltip, IconButton, Box } from "@material-ui/core";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";

import { columnTextField, sortableField } from "utils/tables-utils";

import VisibilityIcon from "@mui/icons-material/Visibility";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import EditIcon from "@mui/icons-material/Edit";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";

// react-bootstrap-table2 chama isso com o order que ela mesma alterna a cada clique
// (mesmo em modo remote — quem muda é só a origem dos dados, não o ciclo do ícone).
const renderSortCaret = (order) => {
  if (order === "asc")
    return <ArrowUpwardIcon style={{ fontSize: 14, marginLeft: 4, verticalAlign: "middle" }} />;
  if (order === "desc")
    return <ArrowDownwardIcon style={{ fontSize: 14, marginLeft: 4, verticalAlign: "middle" }} />;
  return (
    <UnfoldMoreIcon
      style={{ fontSize: 14, marginLeft: 4, opacity: 0.4, verticalAlign: "middle" }}
    />
  );
};

export default function TableVitrines({
  data,
  loading,
  loadingDetails,
  totalSize,
  currentPage,
  currentSizePerPage,
  onTableChange,
  onPageChange,
  handleViewDetails,
  handleEdit,
  isRepresentative = false,
}) {
  const history = useHistory();

  const columnModel = [
    sortableField({
      dataField: "IdVitrineVirtualB2b",
      text: "Cód. Vitrine",
      align: "center",
      sortCaret: renderSortCaret,
    }),
    sortableField({
      dataField: "Nome",
      text: "Vitrine",
      align: "left",
      style: {
        maxWidth: "20vw",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
      sortCaret: renderSortCaret,
    }),
    sortableField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (_, row) =>
        row.Status.charAt(0).toUpperCase() + row.Status.slice(1).toLowerCase(),
      sortCaret: renderSortCaret,
    }),
    columnTextField({
      dataField: "NomeUsuario",
      text: "Criada Por",
      align: "center",
    }),
    sortableField({
      dataField: "DataInclusaoFormat",
      text: "Data Criação",
      align: "center",
      sortCaret: renderSortCaret,
    }),
    sortableField({
      dataField: "DataPublicacaoFormat",
      text: "Data Publicação",
      align: "center",
      sortCaret: renderSortCaret,
    }),
    sortableField({
      dataField: "DataVigenciaInicioFormat",
      text: "Vigência",
      align: "center",
      formatter: (_, row) => (
        <>
          {row?.DataVigenciaInicioFormat} - {row?.DataVigenciaFimFormat}
        </>
      ),
      sortCaret: renderSortCaret,
    }),
    {
      dataField: "selected",
      text: "",
      align: "center",
      headerAlign: "center",
      formatter: (_, row) => (
        <Box display="flex" justifyContent="flex-start" style={{ gap: 4 }}>
          <Tooltip title="Visualizar Vitrine">
            <IconButton
              size="small"
              aria-label="details"
              onClick={() => handleViewDetails(row.IdVitrineVirtualB2b)}
              disabled={loadingDetails}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          {row.Status !== "FINALIZADO" && !isRepresentative ? (
            <Tooltip title="Editar Vitrine">
              <IconButton
                size="small"
                aria-label="edit"
                onClick={() => handleEdit(row.IdVitrineVirtualB2b)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          ) : null}
          {row.Status !== "FINALIZADO" &&
          (row.Status === "CADASTRADO" || row.PodePublicar) ? (
            <Tooltip title="Publicar Vitrine">
              <IconButton
                size="small"
                aria-label="publish"
                onClick={() => {
                  history.push(
                    `/admin/publicar-vitrine-b2b?id=${row.IdVitrineVirtualB2b}`,
                  );
                }}
              >
                <Inventory2OutlinedIcon />
              </IconButton>
            </Tooltip>
          ) : null}
        </Box>
      ),
    },
  ];

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange],
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange],
  );

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando dados..." />
      ) : (
        <ToolkitTable
          keyField="IdVitrine"
          dataTable={data}
          columnModel={columnModel}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: onTableChange,
          }}
          pagination={{
            options: [25, 50, 100],
            totalSize: totalSize,
            page: currentPage + 1,
            sizePerPage: currentSizePerPage,
            defaultOption: 25,
            showTotal: true,
            onPageChange: handlePageChange,
            onSizePerPageChange: handleSizePerPageChange,
          }}
        />
      )}
    </div>
  );
}
